export const state = {
  	// list of instruments we're interestd in   
  registerData :[],
  paymentData : {},
  timeSlots :[]



}


// WEBPACK FOOTER //
// ./src/plugins/giniView/provider/candle-history/store-addons/state.js